// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CanarySurfaceTsx from "./CanarySurface.tsx";

let make = CanarySurfaceTsx.Surface;

export {
  make,
}
/* make Not a pure module */
